class Post {
    id;
    title;
    content;
    contentImageURL;
    publicationDate;
    author;
    segments;
    isSeen;
    constructor(postData) {
        this.id = postData.id;
        this.title = postData.title;
        this.content = postData.content;
        this.contentImageURL = postData.contentImageURL;
        this.publicationDate = new Date(postData.publicationDate);
        this.author = postData.author;
        this.segments = postData.segments;
        this.isSeen = false;
    }
    markAsSeen() {
        this.isSeen = true;
    }
    markAsUnseen() {
        this.isSeen = false;
    }
    isPostSeen() {
        return this.isSeen;
    }
}
export default Post;
